// Resources data for Timberlake Flooring
// Documents available from Peakstone

export const resources = {
  sellSheets: [
    {
      id: 1,
      title: "ComfortSense™ Collection - Sell Sheet",
      collection: "ComfortSense",
      type: "Water-Resistant Laminate",
      thumbnail: "https://images.unsplash.com/photo-1626551039948-ddd7e595fe06?w=300&h=400&fit=crop",
      description: "Product specifications and features for ComfortSense Water-Resistant Laminate flooring",
      fileType: "PDF",
      available: true
    },
    {
      id: 2,
      title: "SolidSense™ Collection - Sell Sheet",
      collection: "SolidSense",
      type: "Rigid-Core Vinyl (SPC)",
      thumbnail: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=300&h=400&fit=crop",
      description: "Product specifications and features for SolidSense Rigid-Core Vinyl flooring",
      fileType: "PDF",
      available: true
    },
    {
      id: 3,
      title: "NatureSense™ Collection - Sell Sheet",
      collection: "NatureSense",
      type: "Engineered Hardwood",
      thumbnail: "https://images.unsplash.com/photo-1560185008-b033106af5c3?w=300&h=400&fit=crop",
      description: "Product specifications and features for NatureSense Engineered Hardwood flooring",
      fileType: "PDF",
      available: true
    }
  ],

  warranties: [
    {
      id: 4,
      title: "Water-Resistant Laminate - Limited Warranty",
      collection: "ComfortSense",
      type: "Warranty Document",
      thumbnail: "https://images.unsplash.com/photo-1575204015311-0fe377370780?w=300&h=400&fit=crop",
      description: "25-year limited warranty for ComfortSense laminate flooring",
      fileType: "PDF",
      warranty: "25 years",
      available: true
    },
    {
      id: 5,
      title: "Rigid-Core Vinyl (SPC) - Limited Warranty",
      collection: "SolidSense",
      type: "Warranty Document",
      thumbnail: "https://images.unsplash.com/photo-1598718544285-7180f670198b?w=300&h=400&fit=crop",
      description: "Lifetime residential limited warranty for SolidSense vinyl flooring",
      fileType: "PDF",
      warranty: "Lifetime Residential",
      available: true
    },
    {
      id: 6,
      title: "Engineered Hardwood - Limited Warranty",
      collection: "NatureSense",
      type: "Warranty Document",
      thumbnail: "https://images.unsplash.com/photo-1686056040167-1e3dead46d9a?w=300&h=400&fit=crop",
      description: "50-year limited warranty for NatureSense engineered hardwood flooring",
      fileType: "PDF",
      warranty: "50 years",
      available: true
    }
  ],

  certifications: [
    {
      id: 7,
      title: "FloorScore Certification",
      type: "Environmental Certification",
      thumbnail: "https://images.unsplash.com/photo-1560185008-b033106af5c3?w=300&h=400&fit=crop",
      description: "Indoor air quality certification for low-emission flooring products",
      fileType: "PDF",
      available: true
    }
  ],

  installationGuides: [
    {
      id: 8,
      title: "Water-Resistant Laminate - Installation Guide",
      collection: "ComfortSense",
      type: "Installation Instructions",
      thumbnail: "https://images.unsplash.com/photo-1626551039948-ddd7e595fe06?w=300&h=400&fit=crop",
      description: "Step-by-step installation instructions for laminate flooring",
      fileType: "PDF",
      available: true
    },
    {
      id: 9,
      title: "Rigid-Core Vinyl (SPC) - Installation Guide",
      collection: "SolidSense",
      type: "Installation Instructions",
      thumbnail: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=300&h=400&fit=crop",
      description: "Step-by-step installation instructions for rigid-core vinyl flooring",
      fileType: "PDF",
      available: true
    },
    {
      id: 10,
      title: "Engineered Hardwood - Installation Guide",
      collection: "NatureSense",
      type: "Installation Instructions",
      thumbnail: "https://images.unsplash.com/photo-1560185008-b033106af5c3?w=300&h=400&fit=crop",
      description: "Step-by-step installation instructions for engineered hardwood flooring",
      fileType: "PDF",
      available: true
    }
  ],

  maintenanceGuides: [
    {
      id: 11,
      title: "Water-Resistant Laminate - Care & Maintenance Guide",
      collection: "ComfortSense",
      type: "Care Instructions",
      thumbnail: "https://images.unsplash.com/photo-1575204015311-0fe377370780?w=300&h=400&fit=crop",
      description: "Care and maintenance instructions to keep your laminate flooring beautiful",
      fileType: "PDF",
      available: true
    },
    {
      id: 12,
      title: "Rigid-Core Vinyl (SPC) - Care & Maintenance Guide",
      collection: "SolidSense",
      type: "Care Instructions",
      thumbnail: "https://images.unsplash.com/photo-1598718544285-7180f670198b?w=300&h=400&fit=crop",
      description: "Care and maintenance instructions to keep your vinyl flooring beautiful",
      fileType: "PDF",
      available: true
    },
    {
      id: 13,
      title: "Engineered Hardwood - Care & Maintenance Guide",
      collection: "NatureSense",
      type: "Care Instructions",
      thumbnail: "https://images.unsplash.com/photo-1686056040167-1e3dead46d9a?w=300&h=400&fit=crop",
      description: "Care and maintenance instructions to keep your hardwood flooring beautiful",
      fileType: "PDF",
      available: true
    }
  ]
};

export const resourceCategories = [
  {
    id: "sell-sheets",
    title: "Collection Sell Sheets",
    description: "Product specifications and features for each collection",
    icon: "FileText"
  },
  {
    id: "warranties",
    title: "Product Warranties",
    description: "Limited warranty information for all flooring products",
    icon: "Shield"
  },
  {
    id: "certifications",
    title: "Certifications",
    description: "Environmental and quality certifications",
    icon: "Award"
  },
  {
    id: "installation",
    title: "Installation Instructions",
    description: "Step-by-step installation guides",
    icon: "Wrench"
  },
  {
    id: "maintenance",
    title: "Care & Maintenance Guides",
    description: "Keep your floors looking beautiful for years",
    icon: "Droplet"
  }
];
